import styled from 'styled-components';
import Logo from '~/components/Logo';

export const Container = styled.div`
	padding: 40px 60px;
	max-width: 1200px;
	margin: 0 auto;

	@media (max-width: ${({ theme }) => theme.breakpoints.medium}px) {
		padding: 40px;
	}
`;

export const TransitionContainer = styled.div`
	position: relative;
	width: 100%;
	overflow: hidden;
`;

export const BottomFrame = styled.div`
	border-radius: 0.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 5rem;
	position: relative;
	z-index: 1;
	background-color: ${({ theme }) => theme.tokens.COLOR_PRIMITIVES_GREY_700};

	@media (max-width: ${({ theme }) => theme.breakpoints.medium}px) {
		padding: 2rem;
	}
`;

export const BottomImage = styled.img`
	width: auto;
	height: auto;
	max-width: 100%;
	border-radius: 0.5rem;
	filter: grayscale(100%);
`;

export const TopFrame = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border-radius: 0.5rem;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 5rem;
	z-index: 2;
	background-color: ${({ theme }) => theme.tokens.COLOR_PRIMITIVES_BLUE_500};

	@media (max-width: ${({ theme }) => theme.breakpoints.medium}px) {
		padding: 2rem;
	}
`;

export const TopImage = styled.img`
	width: auto;
	height: auto;
	max-width: 100%;
	border-radius: 0.5rem;
	z-index: 1;
`;

export const StyledLogo = styled(Logo)`
	position: absolute;
	bottom: 2rem;
	left: 50%;
	transform: translateX(-50%);
	height: 1.5rem;
	z-index: 10;

	@media (max-width: ${({ theme }) => theme.breakpoints.medium}px) {
		bottom: 1rem;
		height: 1.2rem;
	}
`;

export const CompetitorLogoWrapper = styled.div`
	position: absolute;
	bottom: 2rem;
	left: 50%;
	transform: translateX(-50%);
	z-index: 10;
	display: flex;
	align-items: center;
	gap: 8px;

	@media (max-width: ${({ theme }) => theme.breakpoints.medium}px) {
		bottom: 1rem;
	}
`;

export const CompetitorLogoText = styled.span`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.tokens.COLOR_PRIMITIVES_GREY_200};

	@media (max-width: ${({ theme }) => theme.breakpoints.medium}px) {
		font-size: 14px;
	}
`;

export const BlurOverlay = styled.div`
	position: absolute;
	inset: 0;
	backdrop-filter: blur(12px);
	z-index: 3;
`;
